import { putApi } from "./api_instance";

export const resetPassword = async ({ password, userId, token }, dispatch) => {
  try {
    const { data } = await putApi({
      apiUrl: "/api/user/resetPassword",
      dispatch,
      data: { password, userId, token },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
